export default "dist/furniture/ajax-loader.gif";